import WaldoHeadshot from "../../../../src/images/Waldo_Waldman_headshot.png";
import CoverImg from "../../../../src/components/cover-img";
import * as React from 'react';
export default {
  WaldoHeadshot,
  CoverImg,
  React
};